import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import useAuth from "../../routes/login/AuthContext";

import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { useSnackbar } from "../../hooks/useSnackbar";
import Api from "../../services/Api";
import { Box } from "../../UI/Box";
import { Link } from "../Link";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import { Checkbox } from "../../UI/Checkbox";

interface IProps {
  isOpen: boolean;
  subnetwork: number | null;
  onSuccess: VoidFunction;
  values: string[];
  onClose: VoidFunction;
  objectType: string;
}

export const HousingAndMajorsReplacementModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { showErrorSnackbar } = useSnackbar();
  const [accepted, setAccepted] = React.useState(false);
  const { getAuthToken } = useAuth();
  const { selectedNetworkId } = useSelectedNetworkContext();

  React.useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  const handleConfirm = async () => {
    const success = await Api.requestReplaceHousingMajorEntries(
      selectedNetworkId,
      props.subnetwork,
      props.values,
      props.objectType.toLowerCase(),
      await getAuthToken()
    );

    if (!success.error) {
      props.onSuccess();
    } else {
      showErrorSnackbar("Something bad happened");
    }
  };

  const handleAccept = (e: any) => {
    setAccepted(e.target.checked);
  };

  return (
    <Modal
      maxWidth="md"
      onClose={props.onClose}
      title={`Confirm ${props.objectType} Replacement`}
      actions={
        <>
          <Button appearance="subtle" onClick={props.onClose}>
            Cancel
          </Button>
          <Button appearance="primary" onClick={handleConfirm} isDisabled={!accepted}>
            Finalize {props.objectType} Replacement
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          You are about to remove all {props.objectType} options from the subnetwork and replace with the following
          list:
        </Typography>
        <ul>
          {props.values.map((x) => (
            <li>{x}</li>
          ))}
        </ul>
        <Typography variant="body2" gutterBottom>
          If you have questions, please call us at {PHONE_NUMBER} or e-mail{" "}
          <Link href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</Link>
        </Typography>
        <Checkbox
          name="accept"
          defaultChecked={false}
          onChange={handleAccept}
          label={`I understand that the list of ${props.objectType} options above will completely replace my current ${props.objectType} options.`}
        />
      </Box>
    </Modal>
  );
};
